var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpennode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.945 14.034c0 3.795-2.871 6.66-6.714 6.66-3.845 0-6.7-2.865-6.7-6.66 0-3.792 2.855-6.658 6.7-6.658 3.843 0 6.714 2.866 6.714 6.658zm-11.185 0c0 2.677 1.922 4.601 4.471 4.601 2.537 0 4.47-1.924 4.47-4.6 0-2.678-1.933-4.588-4.47-4.588-2.55 0-4.47 1.91-4.47 4.587zm26.165 0c0 3.863-2.788 6.66-6.34 6.66-2.002 0-3.482-.78-4.47-1.978v7.09h-2.176V7.644h2.175v1.708c.99-1.196 2.47-1.976 4.471-1.976 3.552 0 6.34 2.798 6.34 6.658zm-10.943 0c0 2.625 1.789 4.601 4.351 4.601 2.628 0 4.351-2.057 4.351-4.6 0-2.542-1.762-4.588-4.35-4.588-2.563 0-4.352 1.978-4.352 4.587zm24.973-.04c0 .283-.026.58-.039.82h-9.97c.307 2.651 2.135 3.957 4.31 3.957 1.483 0 2.83-.579 3.913-1.52l1.16 1.507c-1.575 1.479-3.336 1.936-5.205 1.936-3.765 0-6.434-2.677-6.434-6.66 0-3.928 2.656-6.658 6.301-6.658 3.456 0 5.938 2.704 5.964 6.619zm-9.983-.954h7.755c-.267-2.261-1.72-3.714-3.777-3.714-2.24 0-3.643 1.534-3.978 3.714zm23.635-.553v7.938h-2.19v-7.226c0-2.352-1.28-3.74-3.482-3.74-2.043 0-3.752 1.414-3.752 3.795v7.17h-2.175V7.645h2.162v1.669c1.041-1.44 2.682-1.937 4.152-1.937 3.123 0 5.285 2.044 5.285 5.111zm13.858 0v7.938h-2.19v-7.226c0-2.352-1.281-3.74-3.483-3.74-2.043 0-3.751 1.414-3.751 3.795v7.17h-2.176V7.645h2.163v1.669c1.04-1.44 2.682-1.937 4.151-1.937 3.123 0 5.286 2.044 5.286 5.111zm15.173 1.547c0 3.795-2.871 6.66-6.714 6.66-3.845 0-6.7-2.865-6.7-6.66 0-3.792 2.855-6.658 6.7-6.658 3.843 0 6.714 2.866 6.714 6.658zm-11.185 0c0 2.677 1.922 4.601 4.47 4.601 2.537 0 4.472-1.924 4.472-4.6 0-2.678-1.935-4.588-4.471-4.588-2.55 0-4.47 1.91-4.47 4.587zm23.52-4.668V2.258l2.189.005v18.162h-2.189v-1.709c-1 1.198-2.482 1.978-4.47 1.978-3.565 0-6.34-2.797-6.34-6.66 0-3.86 2.775-6.658 6.34-6.658 1.988 0 3.47.78 4.47 1.99zm-8.58 4.668c0 2.544 1.76 4.601 4.364 4.601 2.562 0 4.351-1.976 4.351-4.6 0-2.61-1.789-4.588-4.351-4.588-2.643 0-4.365 2.046-4.365 4.587zm24.558-.04c0 .283-.026.58-.039.82h-9.97c.307 2.651 2.135 3.957 4.31 3.957 1.483 0 2.83-.579 3.913-1.52l1.16 1.507c-1.575 1.479-3.336 1.936-5.205 1.936-3.764 0-6.433-2.677-6.433-6.66 0-3.928 2.656-6.658 6.3-6.658 3.456 0 5.938 2.704 5.964 6.619zm-9.982-.954h7.755c-.268-2.261-1.722-3.714-3.778-3.714-2.24 0-3.643 1.534-3.977 3.714z",
    fill: "#1D2229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#655AE6",
    d: "M24.002 20.954V6.984L12 0v13.969z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A50CE",
    d: "M24.002 6.985L12 0v13.969z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#655AE6",
    d: "M24.002 20.953l-12-6.984 12-6.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4896F0",
    d: "M24.002 20.954l-12-6.985L0 20.953l12.001 6.985z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4896F0",
    d: "M12.001 27.937V13.97l12.001 6.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4086D7",
    d: "M0 20.953l12.001-6.984v13.968z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5D980",
    d: "M12 0L0 6.984v13.969l12.001-6.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2D268",
    d: "M0 6.984v13.969l12.001-6.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FADA70",
    d: "M12 0L0 6.984l12.001 6.985z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpennode);
export default __webpack_public_path__ + "static/media/Opennode.00f39e7d0bd504e86182b1aba25fa5aa.svg";
export { ForwardRef as ReactComponent };